import React from 'react';

import stat2040Graphic from '@backrs_ui/grow-ui/src/assets/images/internships/stat-20-40.svg';
import stat3xGraphic from '@backrs_ui/grow-ui/src/assets/images/internships/stat-3x.svg';
import stat50Graphic from '@backrs_ui/grow-ui/src/assets/images/internships/stat-50.svg';
import type {
  InternshipGuideOverviewStat,
  InternshipGuideStatId,
} from '@backrs_ui/grow-ui/src/pages/InternshipGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type OverviewStatCardsProps = Readonly<{
  stats: readonly InternshipGuideOverviewStat[];
}>;

const STAT_GRAPHICS: Record<InternshipGuideStatId, string> = {
  'hidden-opportunities': stat50Graphic,
  'targeted-applications': stat2040Graphic,
  'more-interviews': stat3xGraphic,
};

export const OverviewStatCards: React.FC<OverviewStatCardsProps> = ({ stats }) => (
  <Box sx={gridSx}>
    {stats.map((stat) => (
      <Box key={stat.id} id={`internship-guide-stat-${stat.id}`} sx={cardSx}>
        <Box component="img" src={STAT_GRAPHICS[stat.id]} alt={stat.title} sx={graphicSx} />
        <Box sx={bodySx}>
          <Typography variant="text-lg-semibold" sx={titleSx}>
            {stat.title}
          </Typography>
          <Typography variant="text-sm-regular" sx={descriptionSx}>
            {stat.description}
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
);

const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: backrs.spacing['spacing-xl'],
  mt: backrs.spacing['spacing-3xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
});

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
  borderRadius: backrs.radius['radius-xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
});

const graphicSx: SxProps<Theme> = {
  display: 'block',
  width: '100%',
  height: 'auto',
};

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  p: backrs.spacing['spacing-xl'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const descriptionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
